import { render, staticRenderFns } from "./aPricingStrategyCardStrategyRuleMini.vue?vue&type=template&id=0dd1194c&scoped=true"
import script from "./aPricingStrategyCardStrategyRuleMini.vue?vue&type=script&lang=js"
export * from "./aPricingStrategyCardStrategyRuleMini.vue?vue&type=script&lang=js"
import style0 from "./aPricingStrategyCardStrategyRuleMini.vue?vue&type=style&index=0&id=0dd1194c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd1194c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VIcon,VTooltip})
